import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation ApproveFreeAccess($uid: String!){
        approve_free_access (user_uid: $uid) {
            success
        }
    }
`;

export async function userApproveFreeAccess(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ approve_free_access: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.approve_free_access;
}
